import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CircularProgress from '@mui/material/CircularProgress';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { AxiosResponse } from 'axios';

import { downloadBlobResponse } from '../DownloadReport/downloadUtils';

// A menu item that fetches a zip export blob and triggers a browser download.
export default function ExportDownloadMenuItem({ label, fallbackFilename, fetchExport, onComplete }: {
  label: string;
  fallbackFilename: string;
  fetchExport: () => Promise<AxiosResponse<Blob>>;
  onComplete?: () => void;
}) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    try {
      setLoading(true);
      const response = await fetchExport();
      downloadBlobResponse(response, fallbackFilename);
    } catch (error) {
      console.error('Failed to download export:', error);
    } finally {
      setLoading(false);
      onComplete?.();
    }
  };

  return (
    <MenuItem onClick={handleClick} disabled={loading}>
      <ListItemIcon sx={{ minWidth: 28 }}>
        {loading ? <CircularProgress size={16} /> : <FileDownloadOutlinedIcon fontSize="small" />}
      </ListItemIcon>
      <ListItemText primary={label} />
    </MenuItem>
  );
}
